/** Small shared bits for the two playlist pages. */

import { ApiError } from '@/api/client'

export function trackCountLabel(count: number): string {
  return count === 1 ? '1 song' : `${count} songs`
}

/** `42 min`, `1 hr 12 min`. Long form, because this reads as a total rather than a timestamp. */
export function totalDurationLabel(totalMs: number): string {
  const minutes = Math.round(totalMs / 60_000)
  if (minutes < 1) return 'under a minute'
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return rest === 0 ? `${hours} hr` : `${hours} hr ${rest} min`
}

/**
 * A message that is safe to put in front of a user.
 *
 * The API writes `detail` for humans, so it passes through. Anything else — a
 * dropped connection, a JSON parse failure — carries a developer-facing string
 * that would only confuse, so it is replaced by the caller's fallback.
 */
export function describeError(error: unknown, fallback: string): string {
  return error instanceof ApiError ? error.message : fallback
}
